import { BaseHttpResponseError } from './base-http.error';

/**
 * Error Code: 401 - This error occurs when a request is unauthorized
 */
export class UnauthorizedRequest extends BaseHttpResponseError {}
